<template>
  <div class="d-flex align-center">
    <v-checkbox
      class="mr-4 mt-0"
      @change="onChangeHandler"
      v-model="filterValidInventory"
      :value="true"
      :label="$t('inventoried')"
      :ripple="false"
      hide-details
      style="background: transparent !important"
    ></v-checkbox>
    <v-checkbox
      class="mt-0"
      :label="$t('writeOffed')"
      :ripple="false"
      @change="onChangeHandler"
      :value="true"
      v-model="filterInValidInventory"
      hide-details
      style="background: transparent !important"
    ></v-checkbox>
  </div>
</template>

<script>
export default {
  name: "inventory-item-filter",
  components: {},
  props: {
    filter: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      filterValidInventory: true,
      filterInValidInventory: true,
    };
  },
  methods: {
    clear() {
      this.$emit("update:filter", {});
      this.filterValidInventory = true;
      this.filterInValidInventory = true;
      this.$nextTick(() => {
        this.$emit("change", this.filter);
      });
    },
    onChangeHandler() {
      this.filter.valid = this.filterIsValidInventory;
      this.$emit("change", this.filter);
    },
  },
  computed: {
    filterIsValidInventory() {
      if (
        (this.filterInValidInventory && this.filterValidInventory) ||
        (!this.filterInValidInventory && !this.filterValidInventory)
      ) {
        return null;
      }
      return !this.filterInValidInventory;
    },
  },
};
</script>
